import { render, staticRenderFns } from "./CCPAPolicy.vue?vue&type=template&id=774523f2&scoped=true&"
import script from "./CCPAPolicy.vue?vue&type=script&lang=ts&"
export * from "./CCPAPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./CCPAPolicy.vue?vue&type=style&index=0&id=774523f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774523f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('774523f2', component.options)
    } else {
      api.reload('774523f2', component.options)
    }
    module.hot.accept("./CCPAPolicy.vue?vue&type=template&id=774523f2&scoped=true&", function () {
      api.rerender('774523f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/flatpages/CCPAPolicy.vue"
export default component.exports